<!-- Header Mode -->
<ul *ngIf="mode === 'header'" class="navbar-nav ml-auto mr-4 d-none d-lg-flex">
  <ng-container *ngFor="let nextMenu of displayMenuList">
    <li class="nav-item dropdown" dropdown *ngIf="nextMenu.items.length > 1">
      <a class="nav-link dropdown-toggle" tabindex="0" dropdownToggle id="{{nextMenu.label}}Menu" role="button" style="cursor: pointer;">
        {{nextMenu.label}}
      </a>
      <div class="dropdown-menu" *dropdownMenu>
        <a *ngFor="let menuItem of nextMenu.items" class="dropdown-item" [routerLink]="menuItem.route" routerLinkActive="active" id="{{menuItem.label}}MenuItem">
          {{menuItem.label}}
        </a>
      </div>
    </li>
    <li class="nav-item" *ngIf="nextMenu.items.length === 1" routerLinkActive="active">
      <a class="nav-link"
         id="{{nextMenu.label}}Menu"
         [routerLink]="nextMenu.items[0].route"
         routerLinkActive="active"
         #rla="routerLinkActive">
        {{nextMenu.items[0].label}} <span *ngIf="rla.isActive" class="sr-only">(current)</span>
      </a>
    </li>
  </ng-container>
</ul>

<!-- Mobile Mode -->
<div *ngIf="mode === 'mobile'" class="d-lg-none w-100">
  <ul class="navbar-nav w-100">
    <ng-container *ngFor="let nextMenu of displayMenuList">
      <li class="nav-item" *ngIf="nextMenu.items.length > 1">
        <a class="nav-link ml-2" (click)="toggleCollapse(nextMenu.label)" role="button" [attr.aria-expanded]="!isCollapsed[nextMenu.label]" style="cursor: pointer;">
          {{nextMenu.label}}
        </a>
        <div [collapse]="isCollapsed[nextMenu.label]" class="mobile-accordion-menu">
          <ul class="nav flex-column pl-3">
            <li class="nav-item" *ngFor="let menuItem of nextMenu.items">
              <a class="nav-link" [routerLink]="menuItem.route" routerLinkActive="active" (click)="onItemClick()">
                {{menuItem.label}}
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="nav-item" *ngIf="nextMenu.items.length === 1">
        <a class="nav-link ml-2" routerLinkActive="active" [routerLink]="nextMenu.items[0].route" (click)="onItemClick()">
          {{nextMenu.items[0].label}}
        </a>
      </li>
    </ng-container>
  </ul>
</div>

<!-- Footer Mode -->
<div *ngIf="mode === 'footer'" class="footer-links">
    <ng-container *ngFor="let menuItem of footerMenuList; let i = index">
        <a *ngIf="!menuItem.route?.trim().startsWith('http')" [routerLink]="menuItem.route" class="footer-link">{{menuItem.label}}</a>
        <a *ngIf="menuItem.route?.trim().startsWith('http')" [attr.href]="menuItem.route.trim()" target="_blank" class="footer-link">{{menuItem.label}}</a>
        <span *ngIf="i === 2" class="separator"></span>
    </ng-container>
</div>
